import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "col-12 m-0 p-0" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "invalid-feedback-empty hidden text-left font7" }, "Bitte geben Sie Ihren Namen ein.", -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "invalid-feedback text-left font7" }, "Bitte geben Sie Ihren Namen ein.", -1);
const _hoisted_4 = { class: "col-12 m-0 p-0" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "invalid-feedback hidden text-left font7" }, " Deine Telefonnummer scheint nicht korrekt zu sein. ", -1);
const _hoisted_6 = { class: "col-12 m-0 p-0" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", { class: "invalid-feedback-empty hidden text-left font7" }, " Bitte geben Sie Ihre E-Mail Adresse ein. ", -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", { class: "invalid-feedback text-left font7" }, "Diese E-Mail Adresse scheint nicht korrekt zu sein.", -1);
const _hoisted_9 = { class: "col-12 m-0 p-0" };
const _hoisted_10 = { class: "form-group" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("label", {
    for: "device",
    class: "hidden"
}, "Gerätemodel", -1);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("div", { class: "invalid-feedback-empty hidden text-left font7" }, " Bitte gib die Bezeichnung von deinem Gerät ein. ", -1);
const _hoisted_13 = { class: "col-12 m-0 p-0 mb-3" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("label", {
    for: "store",
    class: "hidden"
}, "Store wählen* (Nord, Mitte oder Weserpark)", -1);
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("option", { value: "" }, "Store wählen*", -1);
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("option", { value: "bremen_mitte" }, "Store Mitte", -1);
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("option", { value: "bremen_weserpark" }, "Store Ost (Weserpark)", -1);
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("option", { value: "bremen_nord" }, "Store Nord", -1);
const _hoisted_19 = [
    _hoisted_15,
    _hoisted_16,
    _hoisted_17,
    _hoisted_18
];
const _hoisted_20 = { class: "col-12 m-0 p-0" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("label", {
    for: "damageType",
    class: "hidden"
}, "Schaden wählen", -1);
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("option", { value: "" }, "Schadensart*", -1);
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("option", { value: "Akku defekt" }, "Akku defekt", -1);
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("option", { value: "Display defekt" }, "Display defekt", -1);
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("option", { value: "Sonstiger Schaden" }, "Sonstiger Schaden", -1);
const _hoisted_26 = [
    _hoisted_22,
    _hoisted_23,
    _hoisted_24,
    _hoisted_25
];
const _hoisted_27 = {
    key: 0,
    class: "m-0 p-0"
};
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("label", {
    for: "damageTypeInfoText",
    class: "f5-responsive strong pt-4"
}, " Bitte beschreibe den Schaden genauer und gib uns weitere Informationen zu deinem Gerät (max. 500 Zeichen). ", -1);
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("div", { class: "text-left font8-responsive mt-3 mb-2" }, [
    /*#__PURE__*/ _createTextVNode(" Hier findest Du unsere "),
    /*#__PURE__*/ _createElementVNode("a", {
        href: "/datenschutz",
        target: "_blank",
        title: "Datenschutzbestimmungen",
        class: "link-in-text"
    }, " Datenschutzerklärung ")
], -1);
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("p", { class: "font7-responsive mb-4" }, "*Pflichtfeld", -1);
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("button", {
    class: "buttonBase buttonGreen font6 w-sm-100 font6 mb-4 px-sm-5",
    type: "submit",
    id: "RepairRequest"
}, " Anfrage absenden ", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_base_input = _resolveComponent("base-input");
    const _component_base_email_input = _resolveComponent("base-email-input");
    return (_openBlock(), _createElementBlock("form", {
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event) => (_ctx.sendRepairRequestMail()), ["prevent"])),
        class: "mb-sm-4",
        name: "repair_request_contact_form",
        id: "repair_request_contact_form"
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
                _createVNode(_component_base_input, {
                    modelValue: _ctx.formValues.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.formValues.name) = $event)),
                    type: "text",
                    "data-validation-type": "text",
                    name: "name",
                    placeholder: "Name*",
                    id: "contactName",
                    rules: _ctx.stringRequiredRule
                }, null, 8, ["modelValue", "rules"]),
                _hoisted_2,
                _hoisted_3
            ])
        ]),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
                _createVNode(_component_base_input, {
                    modelValue: _ctx.formValues.phoneNumber,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.formValues.phoneNumber) = $event)),
                    type: "tel",
                    name: "phoneNumber",
                    placeholder: "Telefonnummer",
                    id: "contactPhone"
                }, null, 8, ["modelValue"]),
                _hoisted_5
            ])
        ]),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
                _createVNode(_component_base_email_input, {
                    required: true,
                    modelValue: _ctx.formValues.email,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.formValues.email) = $event)),
                    type: "email",
                    "data-validation-type": "email",
                    name: "email",
                    placeholder: "E-Mail-Adresse*",
                    id: "contactEmail"
                }, null, 8, ["modelValue"]),
                _hoisted_7,
                _hoisted_8
            ])
        ]),
        _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_base_input, {
                    rules: _ctx.stringRequiredRule,
                    modelValue: _ctx.formValues.device,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.formValues.device) = $event)),
                    type: "text",
                    "data-validation-type": "text",
                    name: "device",
                    placeholder: "Gerätemodell*",
                    id: "device"
                }, null, 8, ["rules", "modelValue"]),
                _hoisted_12
            ])
        ]),
        _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.formValues.shop) = $event)),
                class: "custom-select",
                "data-chosen": "",
                name: "store",
                style: { "cursor": "pointer", "height": "48px" }
            }, _hoisted_19, 512), [
                [_vModelSelect, _ctx.formValues.shop]
            ])
        ]),
        _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.formValues.damageType) = $event)),
                class: "custom-select",
                "data-chosen": "",
                name: "damageType",
                style: { "cursor": "pointer", "height": "48px" }
            }, _hoisted_26, 512), [
                [_vModelSelect, _ctx.formValues.damageType]
            ]),
            (_ctx.formValues.damageType === 'Sonstiger Schaden')
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.formValues.damageTypeInfoText) = $event)),
                        maxlength: "500",
                        autoscroll: "",
                        class: "form-control",
                        name: "damageTypeInfoText",
                        style: { "cursor": "pointer", "height": "200px", "overflow": "hidden", "resize": "none" }
                    }, null, 512), [
                        [_vModelText, _ctx.formValues.damageTypeInfoText]
                    ])
                ]))
                : _createCommentVNode("", true)
        ]),
        _hoisted_29,
        _hoisted_30,
        _hoisted_31
    ], 32));
}
